import React, { useEffect } from 'react'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'
import qs from 'qs'
import {
  removeAuthObj,
  getMfaOperationData,
  removeMfaOperationData
} from 'alelo-logic/services/common/storage'

const Mfa = props => {
  document.title = 'Minha Veloe | MFA'
  const vsgSdk = useVsgSdk()
  const { token, resource, nextUrl, previousUrl } = qs.parse(props.location.search, {
    ignoreQueryPrefix: true
  })

  const operationData = getMfaOperationData()
  const isPublicFlow = !!operationData?.operationToken

  useEffect(() => {
    let mfaComponent

    if (!isPublicFlow && !token) {
      props.history.push('/conta/login')
      return null
    }

    if (isPublicFlow) {
      mfaComponent = vsgSdk.renderizarMfaPublico({
        operationToken: operationData.operationToken,
        resource: operationData.resource
      })

      mfaComponent.on('sucesso', () => {
        const successUrl = operationData.successUrl
        removeMfaOperationData()
        props.history.push(successUrl || '/conta/login')
      })

      mfaComponent.on('cancelar', () => {
        removeMfaOperationData()
        props.history.push('/conta/login')
      })
    } else {
      mfaComponent = vsgSdk.renderizarMfa({
        jwtToken: token,
        resource: resource,
        allowFactorManagement: true
      })

      mfaComponent.on('sucesso', () => {
        props.history.push(nextUrl)
      })

      mfaComponent.on('cancelar', () => {
        props.history.push(previousUrl)

        if (previousUrl === '/conta/login') {
          removeAuthObj()
        }
      })
    }
  }, [vsgSdk])

  return (
    <>
      <div id="vsg-mfa" data-testid="vsg-mfa" />
      <div id="vsg-mfa-publico" data-testid="vsg-mfa-publico" />
    </>
  )
}

export default Mfa
